import React from "react";
import OutcomesComponent from "./OutcomesComponent";
import ActualResultsHead from "./ActualResultsHead";

const ActualResultsComponent = ({
  exercise,
  set,
  percentRM,
  units,
  withWeight,
  fromMetric,
  idx,
  load,
  exerciseName,
  prefix,
  expanded,
  toggleExpanded,
  intensityMeasure,
  isRiR,
  hideVelocitySettings,
}) => {
  return (
    <>
      {/* Showing header section only for first set */}
      {idx === 0 && (
        <ActualResultsHead
          exercise={exercise}
          exerciseName={exerciseName}
          prefix={prefix}
          expanded={expanded}
          toggleExpanded={toggleExpanded}
          intensityMeasure={intensityMeasure}
          isRiR={isRiR}
          set={set}
          targetRM={percentRM}
          units={units}
          targetLoad={load}
          hideVelocitySettings={hideVelocitySettings}
        />
      )}
      {/* Actual Results Outcomes */}
      <OutcomesComponent
        exercise={exercise}
        exerciseName={exerciseName}
        prefix={prefix}
        toggleExpanded={toggleExpanded}
        set={set}
        units={units}
        withWeight={withWeight}
        fromMetric={fromMetric}
        idx={idx}
        targetLoad={load}
        targetRM={percentRM}
        expanded={expanded}
        intensityMeasure={intensityMeasure}
        isRiR={isRiR}
        hideVelocitySettings={hideVelocitySettings}
      />
    </>
  );
};

export default ActualResultsComponent;
